module.exports = __webpack_public_path__ + "static/media/work_img3.fcd00eaa.jpg";